import { authFetch } from '~/services/fetch'

export async function getPredictionModels(): Promise<readonly { readonly id: number; readonly name: string }[]> {
  try {
    const { data } = await authFetch({ url: '/prediction-model', method: 'GET' })
    return data
  } catch (error) {
    throw error
  }
}

export async function getPredictionModelById(id: number) {
  if (!id) return null
  const response = await authFetch({ url: `/prediction-model/${id}`, method: 'GET' })
  return response.data
}
